import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    width: '100%',
    padding: 'l',
    alignContent: 'center',
    textAlign: 'center',
    backgroundColor: 'blues.0',
    color: 'white',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    color: 'white',
    marginBottom: ['xs', 'm', 'm'],
  }),
);

themeStyles.addBaseStyles('Subtitle')(
  css({
    color: 'white',
  }),
);

themeStyles.addBaseStyles('LoaderIconContainer')(
  css({
    zIndex: '2',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    minHeight: ['200px', '180px', '400px'],
  }),
);

export default themeStyles;
